function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_11",
  x: 0,
  y: 0,
  width: 131,
  height: 131,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 9,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.082
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5312",
  "data-name": "Group 5312",
  transform: "translate(22.716 13.959)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -22.72, -13.96)",
  filter: "url(#Ellipse_11)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_11-2",
  "data-name": "Ellipse 11",
  cx: 43,
  cy: 43,
  r: 43,
  transform: "translate(22.5 13.5)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  id: "plane",
  d: "M51.246,12.649a.77.77,0,0,0-.832-.119L.445,35.746A.77.77,0,0,0,.43,37.136l14.141,6.94a.77.77,0,0,0,.8-.075L29.12,33.725l-10.793,11.1a.77.77,0,0,0-.216.6l1.075,14a.77.77,0,0,0,1.351.444l7.506-8.7L37.321,55.6a.77.77,0,0,0,1.067-.464L51.473,13.459A.77.77,0,0,0,51.246,12.649Z",
  transform: "translate(13.829 7.735)",
  fill: "#00b2ae"
}));

function SvgStartRewardingNow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartRewardingNow);
export default __webpack_public_path__ + "static/media/start-rewarding-now.45b9286e.svg";
export { ForwardRef as ReactComponent };